import React from "react";
import SEO from "../components/SEO";
import LegalShell from "../components/LegalShell";

export default function CGV() {
  return (
    <LegalShell eyebrow="Légal" title="Conditions Générales de Vente" lastUpdate="29 avril 2026" testid="page-cgv">
      <SEO
        title="CGV — Conditions Générales de Vente MetaConnect"
        description="Conditions Générales de Vente applicables aux services MetaConnect proposés aux professionnels (B2B)."
        canonical="/cgv"
      />

      <p className="legal-note">
        <strong>Préambule&nbsp;:</strong> les présentes Conditions Générales de Vente (CGV)
        s'appliquent exclusivement aux relations commerciales entre MetaConnect et ses clients
        professionnels (B2B). Aucune vente directe n'est réalisée via le site metaconnect.fr&nbsp;;
        toute prestation fait l'objet d'une proposition commerciale signée par les deux parties.
      </p>

      <h2>Article 1 — Identification du prestataire</h2>
      <p>
        Les services sont fournis par&nbsp;: <strong>METACONNECT.FR</strong>, Société par Actions
        Simplifiée (SAS) au capital de 1 000 €, immatriculée au Registre du Commerce et des
        Sociétés d'Orléans sous le numéro 931 999 833 (SIRET&nbsp;: 931 999 833 00011), dont le
        siège social est situé 68 route de la Ferté-Saint-Aubin, 45150 Jargeau, France. N°&nbsp;TVA
        intracommunautaire&nbsp;: FR22 931 999 833. Représentée par son Président, Monsieur Benoît
        Tommasino. Téléphone&nbsp;: 01 89 70 97 49 — Email&nbsp;:
        <a href="mailto:contact@metaconnect.fr"> contact@metaconnect.fr</a>. Ci-après «&nbsp;MetaConnect&nbsp;»
        ou le «&nbsp;Prestataire&nbsp;».
      </p>

      <h2>Article 2 — Objet</h2>
      <p>
        Les présentes CGV ont pour objet de définir les conditions dans lesquelles MetaConnect
        fournit à son client professionnel (ci-après le «&nbsp;Client&nbsp;») les services de sa
        plateforme e-santé interopérable, incluant notamment&nbsp;: modules de coordination de
        soins, intégrations aux référentiels nationaux (INS, DMP, MSSanté, Pro Santé Connect),
        API, hébergement, support et accompagnement.
      </p>

      <h2>Article 3 — Devis et commande</h2>
      <p>
        objet, tout devis fait l'objet d'une proposition commerciale écrite et personnalisée,
        valable trente (30) jours à compter de son émission. La commande devient ferme et
        définitive à compter de la signature du devis ou du bon de commande par le Client,
        accompagnée le cas échéant du versement de l'acompte demandé.
      </p>

      <h2>Article 4 — Tarifs</h2>
      <p>
        Les tarifs applicables sont ceux figurant sur le devis accepté par le Client. Sauf mention
        contraire, les prix sont exprimés en euros, hors taxes (HT). La TVA en vigueur est
        applicable au taux légal à la date de facturation.
      </p>

      <h2>Article 5 — Modalités de paiement</h2>
      <p>
        Sauf stipulation particulière indiquée au devis, les factures sont payables à&nbsp;
        <strong>trente (30) jours fin de mois</strong> à compter de leur date d'émission, par
        virement bancaire.
      </p>
      <p>
        Conformément à l'article L.441-10 du Code de commerce, tout retard de paiement donnera
        lieu de plein droit à des pénalités de retard calculées au taux d'intérêt appliqué par la
        Banque centrale européenne à son opération de refinancement la plus récente, majoré de 10
        points, ainsi qu'à une indemnité forfaitaire pour frais de recouvrement de 40&nbsp;€.
      </p>

      <h2>Article 6 — Livraison &amp; mise en service</h2>
      <p>
        Les délais de mise en service sont précisés au devis. Ils sont donnés à titre indicatif et
        peuvent varier selon la complexité de l'intégration, les prérequis techniques du Client et
        les délais d'obtention des accréditations nécessaires (notamment auprès de l'Agence du
        Numérique en Santé pour Pro Santé Connect ou MSSanté).
      </p>

      <h2>Article 7 — Obligations du Client</h2>
      <p>Le Client s'engage à&nbsp;:</p>
      <ul>
        <li>fournir l'ensemble des informations, documents et accès nécessaires à l'exécution des prestations&nbsp;;</li>
        <li>désigner un interlocuteur référent disposant du pouvoir de décision&nbsp;;</li>
        <li>respecter les obligations légales liées à son activité, notamment en matière de protection des données de santé&nbsp;;</li>
        <li>régler les factures à leur échéance.</li>
      </ul>

      <h2>Article 8 — Obligations de MetaConnect</h2>
      <p>
        MetaConnect s'engage à exécuter les prestations dans les règles de l'art, dans le respect
        des référentiels nationaux du numérique en santé applicables (notamment INS, DMP, MSSanté,
        Pro Santé Connect, hébergement HDS, PGSSI-S) et dans le cadre d'une obligation de moyens.
      </p>

      <h2>Article 9 — Propriété intellectuelle</h2>
      <p>
        MetaConnect conserve l'ensemble des droits de propriété intellectuelle relatifs à la
        plateforme, ses modules, son code source et sa documentation. Le Client bénéficie d'un
        droit d'usage personnel, non exclusif, non cessible et limité à la durée du contrat,
        conforme aux finalités convenues. Toute exploitation au-delà de ce cadre est subordonnée à
        l'accord écrit préalable de MetaConnect.
      </p>

      <h2>Article 10 — Confidentialité</h2>
      <p>
        Les Parties s'engagent à conserver strictement confidentielles toutes les informations
        échangées dans le cadre de leur relation contractuelle, et à ne les divulguer à aucun tiers
        sans accord écrit, pendant toute la durée du contrat et pour une durée de cinq (5) ans
        après son terme.
      </p>

      <h2>Article 11 — Données à caractère personnel &amp; données de santé</h2>
      <p>
        Le traitement des données à caractère personnel est régi par un accord de traitement
        séparé conclu entre les Parties (article 28 RGPD), précisant notamment les finalités, les
        catégories de données, les durées de conservation et les mesures techniques et
        organisationnelles. Les données de santé éventuellement traitées sont hébergées chez un
        hébergeur certifié HDS conformément à l'article L.1111-8 du Code de la santé publique.
      </p>

      <h2>Article 12 — Limitation de responsabilité</h2>
      <p>
        La responsabilité de MetaConnect, toutes causes confondues, est limitée au montant des
        sommes effectivement perçues par MetaConnect au titre du contrat sur les douze (12) mois
        précédant le fait générateur du dommage. MetaConnect ne saurait être tenu responsable des
        dommages indirects, immatériels ou consécutifs (perte de chiffre d'affaires, perte de
        clientèle, atteinte à l'image, etc.).
      </p>

      <h2>Article 13 — Force majeure</h2>
      <p>
        Aucune des Parties ne pourra être tenue pour responsable d'un manquement à ses obligations
        résultant d'un cas de force majeure au sens de l'article 1218 du Code civil.
      </p>

      <h2>Article 14 — Résiliation</h2>
      <p>
        En cas de manquement grave de l'une des Parties à ses obligations contractuelles, et après
        mise en demeure restée sans effet pendant trente (30) jours, l'autre Partie pourra
        résilier le contrat de plein droit, sans préjudice de tous dommages et intérêts auxquels
        elle pourrait prétendre.
      </p>

      <h2>Article 15 — Droit applicable &amp; juridiction</h2>
      <p>
        Les présentes CGV sont soumises au droit français. Tout litige relatif à leur formation,
        interprétation ou exécution relève de la compétence exclusive des tribunaux d'<strong>Orléans</strong>,
        nonobstant pluralité de défendeurs ou appel en garantie.
      </p>

      <h2>Article 16 — Contact</h2>
      <p>
        Pour toute question relative aux présentes CGV&nbsp;:&nbsp;
        <a href="mailto:contact@metaconnect.fr">contact@metaconnect.fr</a>.
      </p>
    </LegalShell>
  );
}
